

/**
 * Tab data
 */
export class TabItem  {
  title: string;
  id =-1;
  active = false;
  isCloseable = false;
  /**
   * Use component and not tmeplate
   */
  component:any;  
  template;

  dataContext:any;
  }

